<template>
  <v-dialog v-model="dialog" max-width="1200px">
    <v-card>
      <v-card-title class="mx-3">
        {{ $t("cloudPrinterSetting.import_err_title") }}
        <v-spacer></v-spacer>
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click="dialog = false">
              fa-times
            </v-icon>
          </template>
          {{ $t("$vuetify.close") }}
        </v-tooltip>
      </v-card-title>
      <v-divider />
      <v-card-text class="px-4 py-8 text-center subtitle-1">
        <v-data-table
          :headers="headers"
          :items="errorData"
          multi-sort
          class="elevation-1 px-4 pt-2"
          disable-pagination
          hide-default-footer
          fixed-header
        >
          <template v-slot:item.error_msg="{ item }">
            <span class="red--text">
              {{ item.error_msg }}
            </span>
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="secondary" outlined @click="dialog = false">
          {{ $t("$vuetify.close") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>

  import {mapState} from "vuex";
  import i18n from "@/i18n";

  export default {
    name: "ImportResultDialog",

    props: {
      value: Boolean,
      errorData: Array
    },
    computed: {
      headers: () => [
        {
          text: i18n.t("cloudPrinterSetting.Fields.sn"),
          align: "start",
          sortable: false,
          value: "sn",
        },
        {
          text: i18n.t("cloudPrinterSetting.Fields.key"),
          align: "start",
          sortable: false,
          value: "printer_key",
        },
        {
          text: i18n.t("cloudPrinterSetting.Fields.remark"),
          align: "start",
          sortable: false,
          value: "remark",
        },
        {
          text: i18n.t("cloudPrinterSetting.Fields.carnum"),
          align: "start",
          sortable: false,
          value: "carnum",
        },
        {
          text: i18n.t("cloudPrinterSetting.Fields.error_msg"),
          align: "start",
          sortable: false,
          value: "error_msg",
        },
      ],
      ...mapState(["loading"]),
    },
    data: () => ({
      dialog: false,
    }),
    methods: {

    },

    watch: {
      value: {
        immediate: true, //初始赋值也调用
        handler() {
          this.dialog = this.value;
        },
      },
      dialog: {
        handler() {
          this.$emit("input", this.dialog);
        },
      },
    },
  };
</script>